import { queryOptions } from '@tanstack/react-query';
import _ from 'lodash';
import { apiClient } from '#/api/api-client';

/**
 * Get the query options for a Joggr AI Chat.
 * @api `GET /_prv/ai/chats`
 * @returns The query options.
 */
export function aiChatsQueryOptions() {
  return queryOptions({
    queryKey: ['GET /_prv/ai/chats'] as const,
    queryFn: async ({ queryKey }) => {
      const [route] = queryKey;
      return apiClient.request(route, {});
    },
  });
}
